import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/styles';
import clsx from 'clsx';

const style = theme => ({
	root: {
		width: '100%',
		height: '100%',
		minHeight: 40,
		position: 'relative',

		'&>*': {
			position: 'absolute',
			top: '50%',
			left: 'calc(50% - 20px)',
			transform: 'translate(-50%, -50%)',
		}
	}
})

function Loading({
	classes,
	size,
	className,
	ref,
}) {
	return (
		<div className={clsx(
			classes.root,
			className
		)}
			ref={ref}
		>
			<div>
				<CircularProgress size={size} />
			</div>
		</div>
	)
}

export default withStyles(style)(Loading);
